import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import { IntegrationEnum } from 'models/InternalIntegrationSetting';
import { QueryKey } from '@tanstack/react-query';
import { Alert } from 'react-bootstrap';
import useDisableIntegrationMutation, {
  IntegrationMutationLevel,
} from 'pages/integrations/hooks/useDisableIntegrationMutation';

const useDisableHostfullyAssistModal = () => {
  const { t } = useTranslation();
  const { openConfirmModal } = useAppModal();
  const { disableIntegration } = useDisableIntegrationMutation();

  const openDisableHostfullyAssistModal = ({
    integrationEnumId,
    queryKey,
  }: {
    integrationEnumId: IntegrationEnum;
    queryKey: QueryKey;
  }) => {
    const handleConfirmDisable = async () => {
      await disableIntegration({
        level: IntegrationMutationLevel.AGENCY,
        enumId: integrationEnumId,
        queryKey,
      });
    };

    openConfirmModal({
      title: t('pageIntegrations.modals.disableHostfullyAssist.title'),
      body: (
        <Alert bsStyle="danger">
          <div>
            {t('pageIntegrations.modals.disableHostfullyAssist.question')}
          </div>
          <div>
            {t('pageIntegrations.modals.disableHostfullyAssist.consequences')}
          </div>
        </Alert>
      ),
      confirmLabel: t(
        'pageIntegrations.modals.disableHostfullyAssist.confirmBtn',
      ),
      cancelLabel: t('common.cancel'),
      confirmColor: 'danger',
      onConfirmAsync: handleConfirmDisable,
    });
  };

  return { openDisableHostfullyAssistModal };
};

export default useDisableHostfullyAssistModal;
